export const CA_INTELLIGENCE_PATH = 'intelligence';
export const CA_INTELLIGENCE_L10N_SCOPE = 'ca-intelligence-client';
export const CA_INTELLIGENCE_FEATURE_TOGGLE = 'capital-access-intelligence-ISD-19475';
